import AddNew from 'Components/Atoms/ExpandableItems/AddNew';
import Loader from 'Components/Atoms/Loader/Loader';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { getAllowedFileTypes, validateFiles } from 'Services/File/FileService';
import { getAccessTokenFromLocal } from 'Services/helpers';
import { fetchFilesByEntityId, uploadFilesForEntityId } from 'Store/Modules/Files/Actions';
import { getFilesByEntityId, isFileUploading } from 'Store/Modules/Files/Selectors';
import { StoreState } from 'Store/Reducers';
import { API_URL } from 'Store/Shared/Middleware/API/Constants';
import File from './File/File';
import styles from './Files.module.sass';

const Files = ({
    id,
    files, isFileUploading, disableAdd,
    ...props
}: FilesProps) => {
    useEffect(() => {
        props.fetchFilesByEntityId(id);
    }, []);

    const handleFileOpen = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.size = 10;
        input.multiple = true;
        input.accept = getAllowedFileTypes.join(',');
        input.onchange = e => {
            // @ts-ignore
            const files = e.target.files;
            processFiles(files);
            input.remove();
        }
        input.click();
    }

    const processFiles = (files) => {
        const isValid = validateFiles(files);
        if (!isValid) return;

        const formData = new FormData();
        for (const file of files) {
            formData.append("files[]", file);
        }

        props.uploadFilesForEntityId(id, formData);
    }

    return <div className={styles['files']}>
        { !isFileUploading && !disableAdd && <AddNew onClick={handleFileOpen}>+ Voeg bestanden toe</AddNew> }
        { isFileUploading && <Loader description='Bestanden uploaden...' /> }
        <br/>

        { files?.map(id => <File key={id} id={id} />) }
    </div>;
};

interface Props {
    id: any
    disableAdd?: boolean
}

const mapState = (state: StoreState, props: Props) => ({
    files: getFilesByEntityId(state, props.id),
    isFileUploading: isFileUploading(state)
});

const mapDispatch = {
    fetchFilesByEntityId,
    uploadFilesForEntityId
};

type FilesProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(Files);